module.exports = __webpack_public_path__ + "static/media/couple-moving.2e54d18f.jpg";